import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import api from "../../util/api";
import swal from "sweetalert";

import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import CurrencyFormat from 'react-currency-format';

import Footer from "../common/Footer";
import Header from "../common/Header";
import Sidebar from "../common/Sidebar";

const Deposits = () => {
  const navigate = useNavigate();

  const [allDeposits, setAllDeposits] = useState([]);
  const [filteredDeposits, setFilteredDeposits] = useState([]);
  const [sum, setSum] = useState(0);

  const [selectedYear, setSelectedYear] = useState("2025");
  const [selectedMonth, setSelectedMonth] = useState("Full Year");

  const years = ["2026", "2025", "2024", "2023"];
  const months = ["Full Year", "January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

  useEffect(() => {
    getDeposits();
  }, []);

  useEffect(() => {
    filterData();
  }, [selectedYear, selectedMonth, allDeposits]);

  async function getDeposits() {
    const token = localStorage.getItem("token");
    try {
      const res = await api.get("/admin/all-deposits", {
        headers: {
          "Authorization": `Bearer ${token}`,
        },
      });
      if (res.data.success) {
        setAllDeposits(res.data.deposits);
      }
    } catch (err) {
      swal("Failed!", "error", {
        button: false,
        timer: 1500
      });
    }
  }

  const filterData = () => {
    let filtered = allDeposits.filter(item => {
      const date = new Date(item.date);
      const itemYear = date.getFullYear().toString();
      const itemMonth = months[date.getMonth() + 1];

      const yearMatch = itemYear === selectedYear;
      const monthMatch = selectedMonth === "Full Year" || itemMonth === selectedMonth;

      return yearMatch && monthMatch;
    });

    setFilteredDeposits(filtered);
    const total = filtered.reduce((prev, current) => prev + +current.amount, 0);
    setSum(total);
  };

  const columns = [
    {
      dataField: "date",
      text: "Date",
      sort: true
    },
    {
      dataField: "reference",
      text: "Reference"
    },
    {
      dataField: "amount",
      text: "Amount (NGN)",
      formatter: (cellContent, row) => (
        <span>
          <CurrencyFormat
            value={row.amount}
            displayType={'text'}
            thousandSeparator={true}
            decimalScale={2}
            fixedDecimalScale={true}
            renderText={value => <div>{value}</div>}
          />
        </span>
      ),
      sort: true
    },
    {
      dataField: "status",
      text: "Status",
      formatter: (cellContent, row) => {
        const status = row.status?.toLowerCase();
        let badgeClass = "bg-secondary";
        if (status === 'success' || status === 'successful') badgeClass = "bg-success";
        else if (status === 'pending') badgeClass = "bg-warning text-dark";
        else if (status === 'failed' || status === 'error') badgeClass = "bg-danger";

        return <span className={`badge ${badgeClass}`}>{row.status}</span>;
      },
      sort: true
    },
    // {
    //   dataField: "id",
    //   text: "Action",
    //   formatter: (cellContent, row) => (
    //     <a
    //       onClick={(e) => {
    //         e.preventDefault();
    //         navigate('/deposit', { state: { deposit: row } });
    //       }}
    //       href="/"
    //       className="text-primary"
    //     >
    //       View Receipt
    //     </a>
    //   )
    // }
  ];

  return (
    <div>
      <Header />
      <Sidebar />
      <main id="main" className="main">
        <div className="pagetitle">
          <div className="d-flex justify-content-between align-items-center flex-wrap">
            <div>
              <h1>Deposits</h1>
              <nav>
                <ol className="breadcrumb">
                  <li className="breadcrumb-item"><a href="/">Home</a></li>
                  <li className="breadcrumb-item active">Deposits</li>
                </ol>
              </nav>
            </div>

            <div className="d-flex gap-2 my-2">
              <select
                className="form-select form-select-sm"
                style={{ width: 'auto' }}
                value={selectedYear}
                onChange={(e) => setSelectedYear(e.target.value)}
              >
                {years.map(y => <option key={y} value={y}>{y}</option>)}
              </select>

              <select
                className="form-select form-select-sm"
                style={{ width: 'auto' }}
                value={selectedMonth}
                onChange={(e) => setSelectedMonth(e.target.value)}
              >
                {months.map(m => <option key={m} value={m}>{m}</option>)}
              </select>
            </div>
          </div>
        </div>

        <section className="section dashboard">
          <div className="row">
            <div className="col-lg-12">
              <div className="row">
                <div className="col-xxl-6 col-md-6">
                  <div className="card info-card sales-card">
                    <div className="card-body">
                      <h5 className="card-title">Deposit Count <span>| {selectedMonth} {selectedYear}</span></h5>
                      <div className="d-flex align-items-center">
                        <div className="card-icon rounded-circle d-flex align-items-center justify-content-center">
                          <i className="bi bi-download" />
                        </div>
                        <div className="ps-3">
                          <h6>{filteredDeposits.length}</h6>
                          <span className="text-muted small pt-2 ps-1">Total Deposits</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-xxl-6 col-md-6">
                  <div className="card info-card revenue-card">
                    <div className="card-body">
                      <h5 className="card-title">Total Value <span>| {selectedYear}</span></h5>
                      <div className="d-flex align-items-center">
                        <div className="card-icon rounded-circle d-flex align-items-center justify-content-center">
                          <i className="bi bi-currency-exchange" />
                        </div>
                        <div className="ps-3">
                          <h6>
                            <CurrencyFormat
                              value={sum}
                              displayType={'text'}
                              thousandSeparator={true}
                              prefix={'NGN '}
                              decimalScale={2}
                              fixedDecimalScale={true}
                              renderText={value => <div>{value}</div>}
                            />
                          </h6>
                          <span className="text-muted small pt-2 ps-1">Filtered Sum</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-12">
                  <div className="card recent-sales overflow-auto">
                    <div className="card-body">
                      <h5 className="card-title">Deposit History <span>| {selectedMonth === "Full Year" ? selectedYear : `${selectedMonth} ${selectedYear}`}</span></h5>
                      <BootstrapTable
                        bootstrap4
                        keyField="id"
                        data={filteredDeposits}
                        columns={columns}
                        bordered={false}
                        pagination={paginationFactory({ sizePerPage: 20 })}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
      <a href="#" className="back-to-top d-flex align-items-center justify-content-center"><i className="bi bi-arrow-up-short" /></a>
    </div>
  );
};

export default Deposits;